import { Injectable } from '@angular/core';

import { StageService } from '../../../stage.service';
import { RailingColorsService } from '../../services/railing-colors.service';
import { HelperLinesService } from '../../../helper-lines.service';
import { SceneryService } from '../../../scenery.service';
import { DataForDisplayingMenuItemsService } from '../../../data-for-displaying-menu-items.service';
import { PostAccentLightsArrangeService } from '../../light/post-accent-lights-arrange.service';

declare var THREE: any;

@Injectable()
export class RailingPostsService {
  posts = [];
  infill;
  horizontalCableForDoublePost: any;
  floor: any;
  currentParams: any;
  singleHorizontalcable: any;
  // pppp: any;

  constructor(
    private stage: StageService,
    private env: SceneryService,
    private postAccentLightsArrangeService: PostAccentLightsArrangeService,
    private railingColorsService: RailingColorsService,
    private helperLinesService: HelperLinesService,
    public dataForMenu: DataForDisplayingMenuItemsService
  ) { }

  // refactor params
  buildPosts(
    floor,
    intermediatePoints,
    cornerPoints,
    cornerPost,
    rotations,
    horizontalCable,
    insideCornerPost,
    intermediatePost,
    TerminationPostsPositions,
    cornerPost45degree,
    cornerPost135degree,
    posts,
    infill,
    horizontalCableForDoublePost,
    singleHorizontalcable?
  ) {
    this.posts = posts;
    this.infill = infill;
    this.floor = floor;
    let i;
    if (singleHorizontalcable) {
      this.singleHorizontalcable = singleHorizontalcable;
    }

    this.updateCurrentParams();

    this.horizontalCableForDoublePost = horizontalCableForDoublePost;

    for (i = 0; i < TerminationPostsPositions.length; i++) {
      const p1 = TerminationPostsPositions[i];
      const post = this.addTerminationPost(p1, intermediatePost);
      this.postAccentLightsArrangeService.addForTerm(post, p1);
    }

    const deckHeight = this.floor.getWorldPosition(new THREE.Vector3()).y;

    for (i = 0; i < cornerPoints.length; i++) {
      if (!cornerPoints[i].notCorner) {
        if (cornerPoints[i].non90) {
          // non-90 corner entries arrive one per adjacent railed side (a full
          // pair only when both sides have railing) and are index-aligned
          // with rotations — handle each on its own instead of assuming pairs
          this.addPost(
            cornerPoints[i],
            'intermediate',
            deckHeight,
            cornerPost,
            intermediatePost,
            horizontalCable,
            insideCornerPost,
            cornerPost45degree,
            cornerPost135degree,
            rotations[i]
          );
        } else {
          this.addPost(
            cornerPoints[i],
            'corner',
            deckHeight,
            cornerPost,
            intermediatePost,
            horizontalCable,
            insideCornerPost,
            cornerPost45degree,
            cornerPost135degree,
            rotations[i]
          );
        }
      }
    }

    for (i = 0; i < intermediatePoints.length; i++) {
      const points = intermediatePoints[i];
      const first = points[0];
      const last = points[points.length - 1];
      for (let j = 0; j < points.length; j++) {
        const point = points[j];
        if (point.corner) {
          continue;
        }
        const post = this.addPost(
          point,
          'intermediate',
          deckHeight,
          cornerPost,
          intermediatePost,
          horizontalCable,
          insideCornerPost,
          cornerPost45degree,
          cornerPost135degree,
          point.rotation,
          point.rotationVector
        );
        this.postAccentLightsArrangeService.add(post, first, last);
      }
    }
  }

  private showHorizontalCable(type, object, position) {
    // cases for showing horizontal calbe
    // between double post
    // http://146.185.164.175:8080/browse/FR-744
    return (
      type === 'corner' &&
      object.userData.entity.cornerType === 'Double' &&
      (this.infill === 'horizontalCableBaserail' || this.infill === 'horizontalCable') &&
      !position.is45 &&
      !position.is135 &&
      !(
        this.currentParams.railingType === 'DesignRail' &&
        (this.currentParams.topRail === '150s' || this.currentParams.topRail === '100s')
      )
    );
  }

  private addPost(
    position,
    type,
    deckHeight,
    cornerPost,
    intermediatePost,
    horizontalCable,
    insideCornerPost,
    cornerPost45degree,
    cornerPost135degree,
    rotation?,
    vector?
  ) {
    let obj = type === 'corner' ? cornerPost.clone() : intermediatePost.clone();

    if (
      type === 'corner' &&
      position.inside &&
      insideCornerPost &&
      (cornerPost.userData.entity.mountType === 'Fascia Bracket Mount' ||
        cornerPost.userData.entity.mountType === 'Fascia Mount')
    ) {
      obj = insideCornerPost.clone();
    }

    if (type === 'corner' && position.is45 && cornerPost45degree) {
      obj = cornerPost45degree.clone();
    }

    if (type === 'corner' && position.is135 && cornerPost135degree) {
      obj = cornerPost135degree.clone();
    }

    obj.name = 'PostContainer';
    obj.visible = true;

    if (rotation) {
      obj.children.forEach(ch => (ch.rotation.y = rotation));
    }

    obj.position.set(
      position.x,
      position.y +
      (intermediatePost.userData.entity && type === 'intermediate'
        ? intermediatePost.userData.entity.height / 2
        : 45),
      position.z
    );

    if (type === 'corner') {
      obj.position.y =
        position.y + (cornerPost.userData.entity ? cornerPost.userData.entity.height / 2 : 45);
    }

    if (intermediatePost.userData.entity && type == 'intermediate') {
      obj.position.y += intermediatePost.userData.entity.placementHeight || 0;
    }

    if (cornerPost.userData.entity && type == 'corner') {
      obj.position.y += cornerPost.userData.entity.placementHeight || 0;
    }

    this.railingColorsService.setExistingColor(obj, 'Post', 'Post');

    obj.children.forEach(ch => (ch.castShadow = ch.name === 'Post'));

    this.stage.add(obj);
    this.setRotaion(vector, obj, () => Math.PI / 2);
    this.posts.push(obj);

    if (this.showHorizontalCable(type, obj, position)) {
      const pointToNextFloorPoint = new THREE.Vector3(
        position.nextFloorPoint.x - position.floorPoint.x,
        0,
        position.nextFloorPoint.y - position.floorPoint.y
      );
      const pointToPreviousFloorPoint = new THREE.Vector3(
        position.previousFloorPoint.x - position.floorPoint.x,
        0,
        position.previousFloorPoint.y - position.floorPoint.y
      );
      const firstPoint = position.intermediatePostPosition.clone();
      const secondPoint = position.intermediatePostPosition.clone();
      const innerOffset = obj.userData.entity.innerOffset ? obj.userData.entity.innerOffset : 0;

      pointToNextFloorPoint.setLength(innerOffset);
      pointToPreviousFloorPoint.setLength(innerOffset);

      firstPoint.add(pointToNextFloorPoint);
      secondPoint.add(pointToPreviousFloorPoint);

      if (this.infill === 'horizontalCable') {
        const height =
          this.horizontalCableForDoublePost.userData.entity.placementHeight +
          this.horizontalCableForDoublePost.userData.entity.height / 2 +
          deckHeight;
        const horizontalCableForDoublePost = this.horizontalCableForDoublePost.clone();
        const length = firstPoint.distanceTo(secondPoint);

        horizontalCableForDoublePost.visible = true;
        horizontalCableForDoublePost.scale.x =
          length / this.horizontalCableForDoublePost.userData.entity.length;
        horizontalCableForDoublePost.position.set(
          (firstPoint.x + secondPoint.x) / 2,
          height,
          (firstPoint.z + secondPoint.z) / 2
        );
        horizontalCableForDoublePost.rotation.y = rotation - Math.PI / 4;

        if (obj.userData.entity.mountType === 'Fascia Bracket Mount') {
          horizontalCableForDoublePost.rotation.y += Math.PI / 2;
        }

        this.stage.add(horizontalCableForDoublePost);
        this.posts.push(horizontalCableForDoublePost);
      }

      if (this.infill === 'horizontalCableBaserail') {
        let count;
        switch (this.currentParams.railingHeight) {
          case "36":
            count = 10;
            break;
          case "38":
            count = 11;
            break;
          case "42":
            count = 12;
            break;
        }
        const height = 5.54 + deckHeight;
        const length = firstPoint.distanceTo(secondPoint);
        const gap = 7.6;
        for (let i = 0; i < count; i++) {
          const horizontalCableForDoublePost = this.singleHorizontalcable.clone();

          horizontalCableForDoublePost.visible = true;
          horizontalCableForDoublePost.scale.x =
            length / this.singleHorizontalcable.userData.entity.width;
          horizontalCableForDoublePost.position.set(
            (firstPoint.x + secondPoint.x) / 2,
            height + gap * (i + 1),
            (firstPoint.z + secondPoint.z) / 2
          );
          horizontalCableForDoublePost.rotation.y = rotation - Math.PI / 4;

          if (obj.userData.entity.mountType === 'Fascia Bracket Mount') {
            horizontalCableForDoublePost.rotation.y += Math.PI / 2;
          }

          this.stage.add(horizontalCableForDoublePost);
          this.posts.push(horizontalCableForDoublePost);
        }
      }
    }
    return obj;
  }

  addTerminationPost(position, intermediatePost) {
    const obj = intermediatePost.clone();

    obj.name = 'PostContainer';

    obj.visible = true;

    obj.position.set(
      position.x,
      position.y +
      (intermediatePost.userData.entity ? intermediatePost.userData.entity.height / 2 : 45),
      position.z
    );

    obj.position.y += intermediatePost.userData.entity.placementHeight || 0;

    var norm = new THREE.Vector3(0, 0, 1);
    var angle = position.vector.angleTo(norm);
    if (position.vector.x < 0) {
      // norm.negate();
      angle = -position.vector.angleTo(norm);
    }

    obj.children.forEach(ch => (ch.rotation.y = angle));

    obj.children.forEach(ch => (ch.castShadow = ch.name === 'Post'));
    this.railingColorsService.setExistingColor(obj, 'Post', 'Post');
    this.stage.add(obj);

    this.posts.push(obj);
    return obj;
  }

  private setRotaion(vector, obj, angleCalculator: (direction, vector) => number) {
    if (vector) {
      vector.setLength(1);
      vector.negate();
      const direction = new THREE.Vector3();
      obj.getWorldDirection(direction);
      for (let i = 0; i < 8; i++) {
        if (
          !(
            direction.x >= vector.x - 0.05 &&
            direction.x <= vector.x + 0.05 &&
            direction.z >= vector.z - 0.05 &&
            direction.z <= vector.z + 0.05
          )
        ) {
          const angle = angleCalculator(direction, vector);
          obj.children.forEach(ch => (ch.rotation.y += angle));
        }
      }
    }
  }

  updateCurrentParams() {
    this.currentParams = this.dataForMenu.getCurrentParams();
  }
}



// WEBPACK FOOTER //
// ./src/app/services/railing/post/services/railing-posts.service.ts